import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../../lib/api";
import { AlertTriangle, HelpCircle } from "lucide-react";

export default function AdminTickets() {
  const [items, setItems] = useState([]);
  const [filter, setFilter] = useState("all");

  const load = async () => {
    const params = filter === "all" ? {} : { status: filter };
    const { data } = await api.get("/tickets", { params });
    setItems(data);
  };

  useEffect(() => { load(); }, [filter]); // eslint-disable-line

  const counts = (s) => items.filter((x) => x.status === s).length;

  return (
    <div className="space-y-6 fade-in" data-testid="admin-tickets-page">
      <div>
        <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-gradient">Tickets & Reports</div>
        <h1 className="font-display text-3xl tracking-tight mt-2">Support-Verwaltung</h1>
      </div>

      <div className="flex gap-2 flex-wrap">
        {["all","open","in_progress","resolved","closed"].map((s) => (
          <button
            key={s}
            onClick={() => setFilter(s)}
            data-testid={`admin-tickets-filter-${s}`}
            className={`px-4 py-2 rounded-sm text-xs uppercase tracking-[0.2em] font-mono border transition-colors ${
              filter === s ? "bg-primary/10 border-primary text-primary" : "border-border text-white/60 hover:border-primary/40"
            }`}
          >
            {s} {s !== "all" && <span className="text-white/40">({counts(s)})</span>}
          </button>
        ))}
      </div>

      <div className="space-y-2">
        {items.length === 0 ? (
          <div className="border border-dashed border-white/10 p-10 text-center font-mono text-xs uppercase tracking-[0.2em] text-white/40">Keine Tickets.</div>
        ) : (
          items.map((t) => (
            <Link key={t.id} to={`/support/${t.id}`} className="card-solid p-4 flex items-center gap-3 hover:border-primary/40 transition-colors" data-testid={`admin-ticket-${t.id}`}>
              {t.type === "report" ? <AlertTriangle className="w-5 h-5 text-magenta" /> : <HelpCircle className="w-5 h-5 text-primary" />}
              <div className="flex-1 min-w-0">
                <div className="font-display text-base truncate">{t.subject}</div>
                <div className="font-mono text-[10px] uppercase tracking-[0.2em] text-white/50 mt-0.5">
                  {t.type} · prio: {t.priority} · von {t.reporter_name}
                  {t.target_name && <> · gegen {t.target_name}</>}
                </div>
              </div>
              <span className={`chip ${
                t.status === "open" ? "border-red-400/40 text-red-400" :
                t.status === "in_progress" ? "border-primary/40 text-primary" :
                t.status === "resolved" ? "border-accent/40 text-accent" :
                "border-white/20 text-white/40"
              }`}>{t.status}</span>
            </Link>
          ))
        )}
      </div>
    </div>
  );
}
